import { c as _c } from "react/compiler-runtime";
export const DaysLeft = t0 => {
  const $ = _c(6);
  const {
    value,
    isEnded
  } = t0;
  if (isEnded || value < 0) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span className="font-600 text-Gray-600 typo-caption1">마감</span>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (value === 0) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <span className="font-600 text-R-500 typo-caption1">오늘 마감</span>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (value < 10) {
    let t1;
    if ($[2] !== value) {
      t1 = <span className="font-600 text-R-300 typo-caption1">{value}일 남음</span>;
      $[2] = value;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    return t1;
  }
  let t1;
  if ($[4] !== value) {
    t1 = <span className="font-600 text-Gray-600 typo-caption1">{value}일 남음</span>;
    $[4] = value;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};